export default __webpack_public_path__ + "static/media/Mark-2-HUD-02.91d558b6.jpg";